/** @format */

import { createFileRoute, redirect } from "@tanstack/react-router";
import { Suspense } from "react";

import { lazyWithRetry } from "@/utils/lazyWithRetry";
import PageLoader from "@/utils/PageLoader";
import { RouteErrorComponent } from "@/utils/RouteErrorComponent";

const VerifyEmailPage = lazyWithRetry(() => import("@/pages/Auth/VerifyEmail"));

export const Route = createFileRoute("/verify-email/$key")({
  beforeLoad: ({ params }) => {
    if (!params.key || params.key.length < 10) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: "/" });
    }
  },
  component: () => (
    <Suspense fallback={<PageLoader />}>
      <VerifyEmailPage />
    </Suspense>
  ),
  errorComponent: RouteErrorComponent,
});
